<template>
  <form
    autocomplete="off"
    @submit.prevent="submitForm"
  >
    <div class="flex flex-col gap-3">
      <TextInput
        v-model.trim="formData.name"
        v-focus
        :validation-error="getValidationError('name')"
        :label="(type === 'goal' ? 'Goal' : 'Sub-goal') + ' name'"
        autofocus
      />

      <label
        for="description"
        class="mb-0"
      >
        Description of Strategy / Priority / KPA
      </label>
      <TextEditorInput
        id="description"
        v-model="formData.description"
        :allow-image-upload="false"
        :validation-error="hasValidationError('description') ? getValidationError('description') : null"
        required
      />

      <ButtonSubmitRow
        class="mt-5"
        :processing="isSubmitting"
        @cancel-clicked="$emit('cancel')"
        @submit-clicked="submitForm"
      />
    </div>
  </form>
</template>

<script setup>
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

import { ButtonSubmitRow } from '@/components/buttons';
import { AppCard } from '@/components/cards';
import { TextEditorInput, TextInput } from '@/components/form-inputs';

import { useFormSubmit } from '@/composables';
import { HttpStatusCode } from 'axios';

const emit = defineEmits(['cancel', 'submitted']);
const props = defineProps({
  model: {
    type: Object,
    default: () => null,
  },
  type: {
    type: String,
    default: 'goal',
  },
});
const processing = defineModel('processing', { type: Boolean });

const { isSubmitting, submit, hasValidationError, getValidationError } = useFormSubmit();
const route = useRoute();

const formData = reactive({
  name: props.model?.name || null,
  description: props.model?.description || null,
  parent: props.model?.parent || null,
  sortOrder: props.model?.sortOrder,
});

const submitForm = async () => {
  processing.value = true;

  const response = await submit(props.model?.id, formData, null, `frameworks/${route.params.framework}/goals`);

  if (response.statusCode === HttpStatusCode.Ok) {
    emit('submitted', response.data);
  }

  processing.value = false;
};

</script>
